<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de pedidos</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: `/guardar-pedido` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="success"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-plus</v-icon
                    >
                </v-btn>
            </template>
            <span>Nuevo pedido</span>
        </v-tooltip>
        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="Pedidos"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
            <template v-slot:item.fecha_alta="{ item }">
                <span>{{ item.fecha_alta }}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <router-link
                    :to="{ path: `/guardar-pedido?id=${item.id}` }"
                    class="action-buttons"
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                </router-link>
                <v-icon
                    @click="openModal(item)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >
            </template>
        </v-data-table>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            search: "",
            headers: [
                { text: "Nº Pedido", value: "id", sortable: false },
                { text: "Nº Factura", value: "contrato.id", sortable: false },
                {
                    text: "CIF",
                    value: "contrato.clientela.cif",
                    sortable: false,
                },
                {
                    text: "Cliente",
                    value: "contrato.clientela.razon_social",
                    sortable: false,
                },
                { text: "Acciones", value: "action", sortable: false },
            ],
            Pedidos: [],
            selectedItem: 0,
            dialog: false,
        };
    },
    created() {
        this.getPedidos();
    },
    methods: {
        getPedidos() {
            axios.get(`api/get-pedidos`).then(
                (res) => {
                    this.Pedidos = res.data.Pedidos;
                    for (let i = 0; i < this.Pedidos.length; i++) {
                        const element = this.Pedidos[i];
                        element.created_at = new Date(
                            element.created_at
                        ).toLocaleDateString();
                    }
                },
                (err) => {
                    this.$custom_error("Error consultando los pedidos");
                }
            );
        },
        openModal(item) {
            this.selectedItem = this.Pedidos.indexOf(item);
            this.dialog = true;
        },
        deleteUser() {
            axios
                .get(`api/delete-pedido/${this.Pedidos[this.selectedItem].id}`)
                .then(
                    (res) => {
                        this.$toast.sucs("Pedido eliminado con éxito");
                        this.dialog = false;
                        this.getPedidos();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el pedido");
                    }
                );
        },
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
